/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Prashant's Portfolio",
  description:
    "From solving tickets to decoding datasets: A Customer Support maestro turned Data Scientist, thriving in the world of analytics!",
  og: {
    title: "Prashant Singh Portfolio",
    type: "website",
    url: "http://prashantsingh.com/",
  },
};

//Home Page
const greeting = {
  title: "Prashant Singh",
  logo_name: "Prashant Singh",
  nickname: "Data Whisperer",
  subTitle:
    "From solving tickets to decoding datasets: A Customer Support maestro turned Data Scientist, thriving in the world of analytics!",
  resumeLink:
    "https://drive.google.com/file/d/1Af92k1CC52p6UvGN09nwID9FEA_H42SJ/view",
  portfolio_repository: "https://github.com/prashantsingh8962",
  githubProfile: "https://github.com/prashantsingh8962",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/prashantsingh8962",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/prashantsingh896/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/@PrashantSingh-k1s",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:prashantsingh89627@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/prashu_kansana/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Data Science",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing and implementing machine learning models for predictive analytics using Python and Scikit-Learn.",
        "⚡ Performing exploratory data analysis (EDA) and feature engineering to enhance model performance.",
        "⚡ Building and evaluating decision tree classifiers, performing statistical analysis, and visualizing data insights.",
        "⚡ Utilizing NLP for text data analysis and pattern recognition.",
        "⚡ Employing tools such as Pandas, NumPy, Matplotlib, and Seaborn for data manipulation and visualization.",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            color: "#150458",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "simple-icons:numpy",
          style: {
            color: "#013243",
          },
        },
        {
          skillName: "Scikit-Learn",
          fontAwesomeClassname: "devicon:scikitlearn",
          style: {
            color: "#F7931E",
          },
        },
        {
          skillName: "Matplotlib",
          fontAwesomeClassname: "logos:matplotlib-icon",
          style: {
            color: "##19E57F",
          },
        },
        {
          skillName: "Seaborn",
          fontAwesomeClassname: "logos:seaborn-icon",
          style: {
            color: "#7C4DFF",
          },
        },
        {
          skillName: "Jupyter Notebook",
          fontAwesomeClassname: "simple-icons:jupyter",
          style: {
            color: "#F37626",
          },
        },
      ],
    },
    {
      title: "Business Analysis & Data Analysis",
      fileName: "BusinessAnalysisImg",
      skills: [
        "⚡ Analyzing data to generate actionable insights and drive business decisions.",
        "⚡ Crafting comprehensive reports and dashboards to visualize performance metrics and trends.",
        "⚡ Utilizing SQL for data querying and Power BI for data visualization and reporting.",
        "⚡ Performing data cleaning and transformation to ensure data quality and accuracy.",
        "⚡ Implementing ETL processes and data integration for improved business intelligence.",
      ],
      softwareSkills: [
        {
          skillName: "SQL",
          fontAwesomeClassname: "vscode-icons:file-type-plsql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "Power BI",
          fontAwesomeClassname: "simple-icons:powerbi",
          style: {
            color: "#F2C811",
          },
        },
        {
          skillName: "Excel",
          fontAwesomeClassname: "simple-icons:microsoftexcel",
          style: {
            color: "#217346",
          },
        },
        {
          skillName: "Tableau",
          fontAwesomeClassname: "simple-icons:tableau",
          style: {
            color: "#E97627",
          },
        },
        {
          skillName: "Alteryx",
          fontAwesomeClassname: "simple-icons:alteryx",
          style: {
            color: "#2D72D9",
          },
        },
        {
          skillName: "SSRS",
          fontAwesomeClassname: "simple-icons:sqlserver",
          style: {
            color: "#CC2927",
          },
        },
        {
          skillName: "SAS",
          fontAwesomeClassname: "simple-icons:sas",
          style: {
            color: "#00A5E0",
          },
        },
      ],
    },
  ],
};


// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/prashukansana",
    },
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/u/Prashant_Singh07/",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/prashantsingh1234",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Data Analytics Bootcamp",
      subtitle: "- Codebasics",
      logo_path: "Codebasics logo.png",
      bootcamp_link: "https://codebasics.io/bootcamps/data-analytics-bootcamp-with-practical-job-assistance",
      alt_name: "Codebasics Data Analytics Bootcamp",
      duration: "Completed in 2023",
      descriptions: [
        "⚡ Comprehensive training in data analysis with practical job assistance.",
        "⚡ Covered essential tools and techniques for data cleaning, visualization, and analysis.",
        "⚡ Worked on real-world projects and case studies to apply learning and enhance skills.",
      ],
      color_code: "#0C9D5899",
    },
    {
      title: "Devi Ahilya Vishwavidyalaya, Indore",
      subtitle: "BSc in Information Technology",
    logo_path: "Devi_Ahilya_Vishwavidyalaya_Logo.png",
      alt_name: "Davv Indore",
      duration: "2018 - 2021",
      descriptions: [
        "⚡ Gained foundational knowledge in data analysis and statistical methods.",
        "⚡ Developed proficiency in key programming languages and tools for data handling.",
        "⚡ Completed projects involving data visualization and interpretation to support decision-making.",
      ],
      website_link: "https://www.dauniv.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Tableau Mini",
      subtitle: "- Codebasics",
      logo_path: "Codebasics logo.png",
      certificate_link:
        "https://codebasics.io/certificate/CB-70-196193",
      alt_name: "Data Analytics Bootcamp",
      color_code: "#0C9D5899",
    },
    {
      title: "SQL (Intermediate)",
      subtitle: "- HackerRank",
      logo_path: "HackerRank_Icon-1000px.png",
      certificate_link:
        "https://www.hackerrank.com/certificates/d4b44bb593c7",
      alt_name: "SQL Intermediate",
      color_code: "#00000099",
    },
    {
      title: "Data Analytics Bootcamp 2.0:",
      subtitle: "- Codebasics",
      logo_path: "Codebasics logo.png",
      certificate_link:
        "https://codebasics.io/certificate/CB-BT-1-196193",
      alt_name: "Data Bootcamp",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Visualization using Tableau",
      subtitle: "- Great learning",
      logo_path: "Great-Learning-logo.jpg",
      certificate_link:
        "https://www.mygreatlearning.com/certificate/OPPKWPKN",
      alt_name: "Great learning",
      color_code: "#1F70C199",
    },
    {
      title: "Data Analytics Essentials",
      subtitle: "- Cisco",
      logo_path: "cisco-icon.png",
      certificate_link:
        "https://www.credly.com/badges/c43240e5-9292-43e3-9003-0f8250955a91/public_url",
      alt_name: "Cisco",
      color_code: "#FFBB0099",
    },
    {
      title: "Excel Essential Formulas and Functions",
      subtitle: "- Jobaaj",
      logo_path: "jobaaj-circle logo.png",
      certificate_link:
        "https://www.jobaajlearnings.com/certificate?file=certificate-73476-10-0.jpeg",
      alt_name: "Jobaaj",
      color_code: "#D83B0199",
    },
    {
      title: "Power BI for Data Analytics",
      subtitle: "- Codebasics",
      logo_path: "Codebasics logo.png",
      certificate_link:
        "https://codebasics.io/certificate/CB-49-196193",
      alt_name: "Codebasics",
      color_code: "#0C9D5899",
    },
    {
      title: "Introduction to Data Science Badge",
      subtitle: "- Cisco",
      logo_path: "cisco-icon.png",
      certificate_link:
        "https://www.credly.com/badges/635dac63-7e7b-478c-bec1-beb9529c928c/public_url",
      alt_name: "Cisco",
      color_code: "#FFBB0099",
    },
    {
      title: "Power BI Workshop",
      subtitle: "- Jobaaj",
      logo_path: "jobaaj-circle logo.png",
      certificate_link:
        "https://www.jobaajlearnings.com/certificate?file=certificate-73476-88-0.jpeg",
      alt_name: "Jobaaj",
      color_code: "#D83B0199",
    },
    {
      title: "SQL Basics",
      subtitle: "- HackerRank",
      logo_path: "HackerRank_Icon-1000px.png",
      certificate_link:
        "https://www.hackerrank.com/certificates/9b590a25e1b3",
      alt_name: "HackerRank",
      color_code: "#00000099",
    },
    {
      title: "Advanced Excel",
      subtitle: "- Codebasics",
      logo_path: "Codebasics logo.png",
      certificate_link:
        "https://codebasics.io/certificate/CB-51-196193",
      alt_name: "Codebasics",
      color_code: "#0C9D5899",
    },
    {
      title: "Basics Of EDA",
      subtitle: "- Great Learning",
      logo_path: "Great-Learning-logo.jpg",
      certificate_link:
        "https://www.mygreatlearning.com/certificate/LQQSGEZW",
      alt_name: "Great learning",
      color_code: "#4285F499",
    },
     {
      title: "Python for data analysis",
      subtitle: "- Codebasics",
      logo_path: "Codebasics logo.png",
      certificate_link:
        "https://codebasics.io/certificate/CB-48-196193",
      alt_name: "Codebasics",
      color_code: "#0C9D5899",
    },
     {
      title: "Learning SQL",
      subtitle: "- Codebasics",
      logo_path: "Codebasics logo.png",
      certificate_link:
        "https://codebasics.io/certificate/CB-50-196193",
      alt_name: "Codebasics",
      color_code: "#0C9D5899",
    },
     {
      title: "SQL and Relational Databases 101",
      subtitle: "- Cognitive Class",
      logo_path: "Cognitive class logo.png",
      certificate_link:
        "https://courses.cognitiveclass.ai/certificates/ecd2fb0dbff049fb915d90593380510f",
      alt_name: "Cognitive Class",
      color_code: "#2A73CC",
    },
  ],
};


// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "As I transition from customer support to data analytics, I am leveraging my hands-on experience gained through internships in the field. My background in customer support has equipped me with a strong understanding of customer behavior and problem-solving skills, which I now apply to data analysis. Through my internships, I have gained practical experience in data collection, analysis, and visualization, allowing me to transform insights into actionable strategies. I am excited to bring my analytical skills and real-world experience to the data analytics field, where I aim to contribute to data-driven decision-making and drive impactful business outcomes.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Internships",
      work: true,
      experiences: [
        {
          title: "Data Science Intern",
          company: "Prodigy InfoTech",
          company_url: "https://prodigyinfotech.dev/",
          logo_path: "Prodigy logo.jpg",
          duration: "Aug 2024 - Sept 2024",
          location: "Work From Home",
          description:
            "Completed a Data Science Internship at Prodigy InfoTech, where I gained hands-on experience in data analysis and applied key data science techniques. The internship provided a foundation for practical skills in a professional environment.",
          color: "#000000",
        },
        {
          title: "Data Science Intern",
          company: "CodSoft",
          company_url: "https://www.codsoft.in/",
          logo_path: "Codsoft logo.jpg",
          duration: "June 2024 - July 2024",
          location: "Work From Home",
          description:
            "Completed a 4-week virtual Data Science Internship at CodSoft, focusing on developing new skills and gaining hands-on experience. Worked on various tasks and projects to enhance my knowledge in data science techniques.",
          color: "#000000",
        },
        {
          title: "Data Analyst Intern",
          company: "Mentorness",
          company_url: "https://www.mentorness.com/",
          logo_path: "Mentorness logo.jpg",
          duration: "Apr 2024 - May 2024",
          location: "Work From Home",
          description:
            "Completed a Data Analytics Internship at Mentorness, working on tasks like SQL analysis, data visualization, and environmental impact assessment. Developed a Power BI dashboard and produced video content to enhance data storytelling skills.",
          color: "#000000",
        },
        {
          title: "Data Analyst Intern",
          company: "Alfido Techno",
          company_url: "https://www.alfidotech.com/",
          logo_path: "Alfido logo.jpg",
          duration: "Feb 2024 - Mar 2024",
          location: "Work From Home",
          description:
            "Conducted comprehensive data analysis on sales, customer behavior analysis and web traffic performance, handling data cleaning, trend analysis, and visualizations using Python (Pandas, Matplotlib/Seaborn) and BI tools like Tableau. Delivered actionable insights through detailed reports, contributing to improved sales strategies and optimized marketing efforts.",
          color: "#000000",
        },
        {
          title: "Data Analyst Intern",
          company: "Cognifyz Technologies",
          company_url: "https://cognifyz.com/",
          logo_path: "cognifyz_techonologies_logo.jpg",
          duration: "Feb 2024 - Mar 2024",
          location: "Work From Home",
          description:
            "During my internship at Cognifyz, I conducted data analysis to identify top cuisines, city-specific restaurant trends, and pricing distribution using statistical tools. I also analyzed customer reviews and online delivery services to provide actionable insights that contribute to business decision-making​",
          color: "#000000",
        },
        {
          title: "Business Analyst Intern",
          company: "KultureHire",
          company_url: "https://kulturehire.com/",
          logo_path: "KultureHire.png",
          duration: "Jan 2024 - Feb 2024",
          location: "Work From Home",
          description:
            "At KultureHire, I led a project analyzing Gen Z's career aspirations using surveys and data analysis techniques. I provided strategic recommendations for employers to attract and retain Gen Z talent, with a focus on aligning company missions with Gen Z values​",
          color: "#000000",
        },
        {
          title: "Data Analyst Intern",
          company: "Technohacks Technologies",
          company_url: "https://home.technohacks.co.in/",
          logo_path: "TechnoHacks logo.jpg",
          duration: "Jan 2024 - Feb 2024",
          location: "Work From Home",
          description:
            "During my internship at TechnoHacks, I completed tasks focused on data cleaning, statistical analysis, and dashboard creation using Power BI and Tableau, providing actionable insights through data visualization​",
          color: "#000000",
        },
        {
          title: "Data Analyst Intern",
          company: "AtliQ Technologies",
          company_url: "https://www.atliq.com/",
          logo_path: "Atliq logo.png",
          duration: "Oct 2023 - Dec 2023",
          location: "Work From Home",
          description:
            "Analyzed three months of sales data from various AtliQ hotels across four different cities. ",
          color: "#000000",
        },         
      ],
    },
    {
      title: "Job Simulation Programs",
      experiences: [
        {
          title: "Accenture North America - Data Analytics and Visualization",
          company: "Accenture",
          company_url: "https://www.theforage.com/simulations/accenture-nam/data-analytics-mmlb",
          logo_path: "Accenture logo.png",
          duration: "Mar 2024 - April 2024",
          location: "Work from Home",
          description:
            "Gained hands-on experience with data analytics tools and techniques, focusing on data interpretation and actionable insights. Applied analytical skills to real-world business scenarios to drive decision-making.",
          color: "#4285F4",
        },  
        {
          title: "Quantium Data Analysis",
          company: "Quantium",
          company_url: "https://www.theforage.com/simulations/quantium/data-analytics-rqkb",
          logo_path: "Quantium logo.jpg",
          duration: "Feb 2023 - Mar 2023",
          location: "Work from Home",
          description:
            "Applied data analytics methodologies to solve business problems and uncover insights. Worked with data sets to derive meaningful conclusions and support strategic decisions.",
          color: "#4285F4",
        },   
        {
          title: "PwC Switzerland - Power BI",
          company: "Pwc Switzerland",
          company_url: "https://www.theforage.com/simulations/pwc-ch/power-bi-cqxg",
          logo_path: "PwC logo.jpg",
          duration: "Jan  2024 - Feb 2024",
          location: "Work from Home",
          description:
            "Mastered Power BI for data analysis and visualization, learning to build interactive dashboards and reports. Focused on translating data into actionable business intelligence through dynamic visualizations.",
          color: "#4285F4",
        },    
        {
          title: "Tata - Data Visualisation: Empowering Business with Effective Insights",
          company: "Tata Groups",
          company_url: "https://www.theforage.com/simulations/tata/data-visualisation-p5xo",
          logo_path: "Tata logo.png",
          duration: "Nov 2023 - Dec 2023",
          location: "Work from Home",
          description:
            "Developed expertise in creating compelling data visualizations to effectively communicate complex data. Utilized advanced visualization tools to enhance storytelling and data-driven insights.",
          color: "#4285F4",
        },                  
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them using Machine learning.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "Choosing-data-analyst-as-career",
      name: "Is Choosing a Data Analysis Career in 2024 Easy or Not?",
      createdAt: "2023-09-13",
      description: "Data Analysis career",
      url: "https://prashantdatauniverse.blogspot.com/2024/09/is-choosing-data-analysis-career-in.html",
    },
    {
      id: "Timely-resolution-in-customer-support",
      name: "Timely resolution in customer support",
      createdAt: "2023-09-13",
      description: "Ensuring Timely Resolution When a Colleague Holds Up Crucial Information",
      url: "https://prashantdatauniverse.blogspot.com/2024/09/ensuring-timely-resolution-when.html",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "prashufinal.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with Advanced Excel, Power BI, SQL , Python, pandas, numpy, matplotlib, scikit-learn, seaborn and Machine Learning.",
  },
  blogSection: {
    title: "Dashboards",
    subtitle:
      "I emphasize my data analytics expertise by incorporating interactive visualizations and user-friendly dashboards. These elements are crafted to enhance decision-making and provide clear, actionable insights for stakeholders.",
    link: "https://www.novypro.com/profile_projects/prashant-1",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Railway Coach Factory, Nishatpura, Bhopal 462010.",
    locality: "Railway Colony",
    country: "India",
    region: "Bhopal",
    postalCode: "462010",
    streetAddress: "CRWS colony",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/Pms27tt1cXHj8NdCA",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91-89627-81887",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
